exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".van-popup .van-checkbox[data-v-0514dd6a]{margin:.267rem}.page[data-v-0514dd6a]{text-align:left}", ""]);

// exports
